import { ProfileTranslation } from 'locales/de/pages/profile';

const en: ProfileTranslation = {
  notificationsSubheader: 'Notification settings',
  summarySettings: 'E-Mail-Summary of new articles',
  summaryInfo: {
    title: 'E-Mail-Summary',
    content:
      'Here you can determine if and how often you want to receive summaries via e-mail. You will only receive summaries of articles from categories you selected in your settings.'
  },
  summaryInfoBlockedDepartments: {
    title: 'Important Notice',
    content: 'You will always receive an e-mail for articles in mandatory categories.'
  },
  autosaveInfo: {
    title: 'Auto-save',
    content: 'Caution! The changes you make here will be saved automatically.'
  },
  notificationSettingsHeaders: {
    bell: 'Bell',
    email: 'E-Mail'
  },
  receive: 'Receive',
  days: {
    oneDay: '1 Day',
    sevenDays: '7 Days',
    fourteenDays: '14 Days'
  }
};

export default en;
